import { Stack, Box } from "@mui/system";
import { Typography } from "@mui/material";
import React from "react";

export interface PopularTopicsProps {
  title: string;
  link: string;
  listItems: {
    image: string;
    name: string;
    tickets: string;
    icons: string;
  }[];
}

const PopularTopicsList = ({ title, link, listItems }: PopularTopicsProps) => {
  return (
    <Stack
      width={400}
      height={400}
      className="background-greish"
    >
      <Box sx={{ padding: "30px" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h4" className="font-white">
              {title}
            </Typography>{" "}
          </Box>
          <Box>
            <Typography className="font-seagreen" variant="h5">
              {link}
            </Typography>
          </Box>
        </Box>

        <Box marginTop={3}>
          {listItems.map((data): any => {
            return (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                paddingBottom="10px"
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box paddingRight="20px">
                    <img width="50px" src={data.image} />
                  </Box>
                  <Box>
                    <Typography variant="h5" className="font-white">
                      {data.name}
                    </Typography>
                    <Typography variant="h6" className="font-seagreen">
                      {data.tickets}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <i className="fas fa-ellipsis-h font-whiteGray"></i>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Stack>
  );
};

export default PopularTopicsList;
